module.exports = __webpack_public_path__ + "img/head.fecf218f.png";